import { isValidUrl } from '@pkg/utils';

export function handleInputValue(event) {
    const { value, type } = event.target;

    switch (type) {
        case 'number': {
            return parseInt(value, 10).toString(); // because the inputs use a string value even if it is a number type
        }
        case 'url': {
            if (!value.length) {
                return null;
            }
            if (value && isValidUrl(value)) {
                return value;
            }
            break;
        }
        default: {
            return value;
        }
    }
}
